import { computed as n, createBlock as i, openBlock as l, normalizeClass as s, withCtx as m, createVNode as u, createElementVNode as d, toDisplayString as p } from "vue";
import f from "../../atoms/anchor-element/anchor-element.vue.js";
import k from "../../atoms/icon-core/icon-core.vue.js";
import { useLazyUrl as _ } from "../../composables/useLazyUrl.js";
import { themeProp as g } from "../../composables/useTheme.js";
/* empty css               */
import x from "../../_virtual/_plugin-vue_export-helper.js";
const y = { "data-j-text": "" }, h = /* @__PURE__ */ Object.assign({
  name: "DsLinkBack"
}, {
  __name: "link-back",
  props: {
    ...g,
    /**
     * Link text
     */
    text: {
      type: String,
      required: !0
    },
    /**
     * Link url, href attribute content
     */
    url: {
      type: String,
      required: !0
    },
    /**
     * decide whether it's a nuxt link or not
     */
    nuxt: {
      type: Boolean,
      default: () => !0
    },
    /**
     * Lazy route endpoint
     */
    lazyUrlEndpoint: {
      type: String,
      default: ""
    },
    /**
     * trackingData, to be set as data-track attributes for tracking purpose
     */
    trackingData: { type: Object, default: () => ({}) }
  },
  setup(t) {
    const e = t, r = n(() => e.lazyUrlEndpoint), { lazyUrl: o } = _(r), c = n(() => e.url || o.value);
    return (a, z) => (l(), i(f, {
      url: c.value,
      "tracking-data": { "component-name": a.$options.name, ...t.trackingData },
      class: s(["ds-link-back", `ds-link-back--${a.theme}`]),
      nuxt: t.nuxt
    }, {
      default: m(() => [
        u(k, {
          class: "ds-text-icon__icon ds-text-icon__icon--left ds-margin-right-4",
          category: "arrows",
          name: "chevron-left-extra-small",
          "data-j-icon-left": ""
        }),
        d("span", y, p(t.text), 1)
      ]),
      _: 1
    }, 8, ["url", "tracking-data", "class", "nuxt"]));
  }
}), S = /* @__PURE__ */ x(h, [["__scopeId", "data-v-0f167a49"]]);
export {
  S as default
};
